import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import { Typography, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { hideModal } from 'state/actions';
import { images } from 'assets/images';
import { MODAL, COLOR, ENG, ADD_NEW_FAVORITE_LISTING_STEP } from 'config/constants';
import { useAuth, useListing, useLanguage } from 'hooks';
import { HvModal, HvButton, HvSearchInput } from 'components';
import { isMobile } from 'utils/screen';
import ListingList from './ListingList';

const useStyles = makeStyles({
  cancelButton: {
    backgroundColor: 'white',
    marginRight: 20,
    color: '#00bdf2',
    border: '1px solid #00bdf2',
  },
  modalContent: {
    display: 'flex',
    flexDirection: 'column',
    width: 900,
    '@media (max-width: 839px)': {
      width: 720,
    },
    '@media (max-width: 768px)': {
      width: 700,
    },
    '@media (max-width: 560px)': {
      width: 500,
    },
    '@media (max-width: 414px)': {
      width: 330,
    },
    '@media (max-width: 380px)': {
      width: 300,
    },
    '@media (max-width: 300px)': {
      width: 280,
    },
  },
  warning: {
    color: 'red',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    marginBottom: 20,
  },
});
interface Props {
  setActiveStep: (_: number) => void;
  activeStep: number;
  selectedListings: any;
  setSelectedListings: (_: any) => void;
  favorite_listings: [];
}
function NewListingSearch({
  setActiveStep,
  activeStep,
  selectedListings,
  setSelectedListings,
  favorite_listings,
}: Props) {
  const intl = useIntl();
  const styles = useStyles();
  const language = useLanguage();
  const dispatch = useDispatch();

  useEffect(() => {});

  const onClose = () => {
    dispatch(hideModal(MODAL.ADD_NEW_FAVORITE_LISTING));
  };

  const onBack = () => {
    setActiveStep(ADD_NEW_FAVORITE_LISTING_STEP.OPTIONS);
  };

  const onNext = () => {
    setActiveStep(ADD_NEW_FAVORITE_LISTING_STEP.CONFIRM);
  };

  const buttons = (
    <Box>
      <HvButton className={styles.cancelButton} onClick={onBack}>
        {intl.formatMessage({ id: 'deliver.photos.back' })}
      </HvButton>
      <HvButton onClick={onNext} disabled={!selectedListings.length}>
        {intl.formatMessage({ id: 'deliver.photos.next' })}
      </HvButton>
    </Box>
  );

  return (
    <HvModal
      title={intl.formatMessage({ id: 'portal.addYourListings' })}
      onClose={onClose}
      buttons={buttons}
      largerWidth
      fullScreen={isMobile()}
    >
      <Box className={styles.modalContent}>
        <ListingList
          selectedListings={selectedListings}
          setSelectedListings={setSelectedListings}
          favorite_listings={favorite_listings}
        />
      </Box>
    </HvModal>
  );
}
export default NewListingSearch;
